import FirstImg from "./CarouselWeddingPhotos/first.webp";
import SecondImg from "./CarouselWeddingPhotos/second.webp";
import ThirdImg from "./CarouselWeddingPhotos/third.webp";
import FourthImg from "./CarouselWeddingPhotos/fourth.webp";
import FifthImg from "./CarouselWeddingPhotos/fifth.webp";
import SixthImg from "./CarouselWeddingPhotos/sixth.webp";
import SeventhImg from "./CarouselWeddingPhotos/seventh.webp";
import EighthImg from "./CarouselWeddingPhotos/eighth.webp";
import NinthImg from "./CarouselWeddingPhotos/ninth.webp";
import TenthImg from "./CarouselWeddingPhotos/tenth.webp";
import EleventhImg from "./CarouselWeddingPhotos/eleventh.webp";
import TwelfthImg from "./CarouselWeddingPhotos/twelfth.webp";

export const images = [
  {
    src: FirstImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 20%", minWidth: "6%" }
  },
  {
    src: SecondImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 20%", minWidth: "6%" }
  },
  {
    src: ThirdImg,
    mobile: { backgroundPosition: "60% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 20%", minWidth: "6%" }
  },
  {
    src: FourthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 40%", minWidth: "6%" }
  },
  {
    src: FifthImg,
    mobile: { backgroundPosition: "50% 15%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 15%", minWidth: "6%" }
  },
  {
    src: SixthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 20%", minWidth: "6%" }
  },
  {
    src: SeventhImg,
    mobile: { backgroundPosition: "40% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 30%", minWidth: "6%" }
  },
  {
    src: EighthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 30%", minWidth: "6%" }
  },
  {
    src: NinthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 35%", minWidth: "6%" }
  },
  {
    src: TenthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 12%", minWidth: "6%" }
  },
  {
    src: EleventhImg,
    mobile: { backgroundPosition: "80% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 15%", minWidth: "6%" }
  },
  {
    src: TwelfthImg,
    mobile: { backgroundPosition: "50% 20%", minWidth: "6%" },
    tablet: { backgroundPosition: "50% 20%", minWidth: "6%" },
    desktop: { backgroundPosition: "50% 60%", minWidth: "6%" }
  }
];